<template>
    <div class="font-main" v-if=trackingInit>
        <router-view :key="$route.path" />
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import { provide, watch } from "vue";
import ConfigManager from "@/config/ConfigManager.js";
//store
import SideMenuStore from "@/store/SideMenuStore.js";
import AccountStore from "@/store/AccountStore.js";
import ModalSetupMixin from '@/mixin/ModalSetupMixin.js';
import PlaceOrderStore from '@/store/PlaceOrderStore.js';
import Shipping from '@/store/ShippingPriceStore.js';
import DeliveryStore from '@/store/DeliveryStore.js';
import CartCountStore from '@/store/CartCountStore.js';
import LocaleStore from "@/store/LocaleStore"
import PointStore from './store/PointStore';
import useSearchStore, { useSearchBar } from "./store/SearchStore";
import useNotificationStore from "./store/NotificationStore";
import HomeStore from "./store/HomeStore";
import CookieStore from './store/CookieStore';
import { useRoute } from 'vue-router'

export default {
    mixins: [ModalSetupMixin],
    setup: function(){
        const routeNotShow = ['OrderSummary','OrderPayment', 'Complete', 'fail'];
        const { lbl, localeCode, getters:localeGetters, setters:localeSetters } = LocaleStore();
        provide('LocaleStore', { lbl, localeCode, localeGetters, localeSetters });
        useSearchStore()
        useSearchBar()
        const noti = useNotificationStore();
        noti.methods.getNotifications();
        CookieStore.methods.init();
        const route = useRoute();
        watch(route, ()=>{
            if (routeNotShow.indexOf(route.name) > -1) {
                CookieStore.methods.HideBanner();
            } else {
                CookieStore.methods.init();
            }
            console.log('route.name', route.name)
        })
        return {
            lbl
        }
    },
    data: function() {
        return {
            trackingInit: false,
        };
    },
    created: function() {
        console.log("run local environment", ConfigManager.getApi());
        AccountStore.methods.init();
        AccountStore.methods.loginStatus().subscribe(() => {
            if (AccountStore.state.isLogin) {
                DeliveryStore.methods.init();
                CartCountStore.methods.updateCartCount();
            }
        });

    },
    methods: {
        onTrackingInit: function () {
            this.trackingInit = true;
        },
    },
    mounted: function () {
        window.document.title = this.lbl.title;
    },
    provide: {
        SideMenuStore: SideMenuStore,
        AccountStore: AccountStore,
        PlaceOrderStore: PlaceOrderStore,
        ShippingStore: Shipping,
        DeliveryStore: DeliveryStore,
        CartCountStore: CartCountStore,
        PointStore: PointStore,
        HomeStore: HomeStore,
        CookieStore: CookieStore,
    },
}
</script>
<style lang="scss">
    @import "./style/base/base.scss";
    @import "./style/main.scss";
</style>
